import { Editor } from "@tiptap/core";

import { EditorAttributes } from "@/wc/editor/models";

/**
 * Retrieves the instance ID of the editor
 * @param editor - The editor instance
 * @returns The instance ID of the editor
 */
export function getEditorInstanceId(editor: Editor): string {
  const attributes = editor.options.editorProps.attributes as EditorAttributes;
  return attributes.id;
}
